module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-picker"
  }, [_c('h4', [_vm._v("I know this neighborhood:\n    "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.compareNghd),
      expression: "compareNghd"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.compareNghd = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.selectName]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a Neighborhood")]), _vm._v(" "), _vm._l((_vm.nghdNames), function(nghd) {
    return _c('option', {
      domProps: {
        "value": nghd
      }
    }, [_vm._v(_vm._s(nghd))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-24d9d72b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComparePicker.vue
// module id = 175
// module chunks = 1